module.exports = __webpack_public_path__ + "img/minus_btn.1372da01.png";